export interface DataFrameWarningOptions {
  isRandomSubset: boolean;
  name: string;
  renderedColumns: number;
  renderedRows: number;
  totalColumns: number;
  totalRows: number;
}

/**
 * Return a list of warnings to display to the user about the data frame.
 */
export default function getDataFrameWarnings({
  isRandomSubset,
  name,
  renderedColumns,
  renderedRows,
  totalColumns,
  totalRows,
}: DataFrameWarningOptions): Array<string> {
  const messages: Array<string> = [];

  if (renderedRows < totalRows) {
    messages.push(
      `Showing ${isRandomSubset ? 'a random sample of' : 'the first'} ${renderedRows} rows out of ${totalRows} from ${name}`
    );
  }
  if (renderedColumns < totalColumns) {
    messages.push(`Showing the first ${renderedColumns} columns out of ${totalColumns} from ${name}`);
  }

  return messages;
}
